import { Grid, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import { Variant } from "@mui/material/styles/createTypography";

interface Props {
  id?: string;
  variant?: Variant;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const Heading = ({
  id,
  variant,
  children,
  style,
}: PropsWithChildren<Props>) => {
  return (
    <Grid item md={12} xs={12} style={{ padding: 0 }} id={id}>
      <Typography
        variant={variant}
        style={{
          ...style,
          textAlign: "center",
          padding: 0,
          width: "100%",
        }}
      >
        {children}
      </Typography>
    </Grid>
  );
};
